import React, { Component } from 'react';

import styled from '@emotion/styled';

import {
  TabList as TL,
  Tab as T,
  TabTitle as TT,
  TabSubtitle as TS,
  TabStatus as TSS,
  TabInfo as TI,
  ArrowIcon as AI,
  NavIcon as NI,
} from 'views/anyguide/tours/edit/components/tabs/TabStyles';

export const TabList = styled(TL)``;
export const Tab = styled(T)`
  /* font-size: 10px; */
`;
export const TabTitle = styled(TT)`
  line-height: 1.4em;
  &:first-letter {
    text-transform: uppercase;
  }
`;

export const TabSubtitle = styled(TS)`
  &:first-letter {
    text-transform: uppercase;
  }
`;

export const TabStatus = styled(TSS)``;
export const TabInfo = styled(TI)``;
export const ArrowIcon = styled(AI)``;
export const NavIcon = styled(NI)``;
